import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductStockHistoryRBAC = {
  pageID: 'b6031c4f0760e0452a6cdbabc02dc582',
  elementID: {
    TableList: '828641e6f790c61ba4d0007865322fd2',
  },
} as const

export const useRBACProductStockHistoryPage = createUseRBAC(ProductStockHistoryRBAC.elementID)
export type UseRBACProductStockHistoryPageType = ReturnType<typeof useRBACProductStockHistoryPage>

export const ProductStockHistoryHubRBAC = {
  pageID: '9136373c8eaef57d37316ec10f07e74e',
  elementID: {
    TableList: 'ed0258ceace68fae58d344f89f1e37ee',
  },
}
export const useRBACProductStockHistoryHubPage = createUseRBAC(ProductStockHistoryHubRBAC.elementID)
export type UseRBACProductStockHistoryHubPageType = ReturnType<
  typeof useRBACProductStockHistoryHubPage
>
